import { cn } from "@/lib/utils";
import { AnimationProps, MotionProps } from "framer-motion";
import React from "react";
import Balancer from "react-wrap-balancer";

export const Subheading = ({
  className,
  as: Tag = "h2",
  children,
  ...props
}: {
  className?: string;
  as?: any;
  children: any;
  props?: React.HTMLAttributes<HTMLHeadingElement | AnimationProps>;
} & MotionProps &
  React.HTMLAttributes<HTMLHeadingElement | AnimationProps>) => {
  return (
    <p
      className={cn(
        "  max-w-4xl text-left my-4 mx-auto",
        "text-muted text-center text-xl font-normal dark:text-muted-dark",
        className
      )}
    >
      <Balancer>{children}</Balancer>
    </p>
  );
};
